import { MARQUEE_ITEMS, MARQUEE_ITEMS_EN } from "@/data/content";
import { useLang } from "@/i18n";

export default function Marquee() {
    const { lang } = useLang();
    const items = lang === "en" ? MARQUEE_ITEMS_EN : MARQUEE_ITEMS;
    const doubled = [...items, ...items, ...items, ...items];
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden border-y border-white/5 bg-[#0a0a0d] py-6"
            aria-hidden="true"
        >
            <div className="flex w-max animate-marquee items-center whitespace-nowrap">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {doubled.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="font-display text-xl font-semibold uppercase tracking-[0.12em] text-white/20 sm:text-2xl">
                                    {item}
                                </span>
                                <span className="mx-10 h-1.5 w-1.5 rotate-45 bg-brand/60" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
